import { jsx as _jsx } from "react/jsx-runtime";
import ActivitiesContainer from "src/features/activityLog/ActivitiesContainer";
import useGetActivities from "src/features/activityLog/hooks/useGetActivities";
const ActivitiesContainerWrapper = () => {
    const { activities, isLoading } = useGetActivities();
    return _jsx(ActivitiesContainer, { isLoading: isLoading, activities: activities });
};
export default ActivitiesContainerWrapper;
